var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarouselIconRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.17745 4.93815H4.15365L3.32031 5.74544C3.12934 5.93642 3.03385 6.15777 3.03385 6.40951C3.03385 6.66124 3.12934 6.8826 3.32031 7.07357C3.51128 7.26454 3.73264 7.36437 3.98438 7.37305C4.23611 7.38173 4.45747 7.29058 4.64844 7.09961L7.09635 4.65169C7.28733 4.46704 7.38281 4.25161 7.38281 4.00539C7.38281 3.75917 7.28852 3.54178 7.09995 3.3532L4.64844 0.901692C4.45747 0.71072 4.23611 0.615234 3.98438 0.615234C3.73264 0.615234 3.51128 0.71072 3.32031 0.901692C3.12934 1.09266 3.03385 1.31402 3.03385 1.56575C3.03385 1.81749 3.12934 2.03885 3.32031 2.22982L4.15365 3.06315H1.17745C0.913941 3.06315 0.693056 3.1543 0.514792 3.33659C0.336529 3.51888 0.247396 3.74207 0.247396 4.00615C0.247396 4.27021 0.336529 4.49156 0.514792 4.67021C0.693056 4.84884 0.913941 4.93815 1.17745 4.93815Z",
    fill: "#050220"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselIconRight);
export default __webpack_public_path__ + "static/media/carousel-icon-right.d1823b009631a90d4903148f31eefaad.svg";
export { ForwardRef as ReactComponent };